import { render, staticRenderFns } from "./UpdateMain.vue?vue&type=template&id=6864f0d6"
import script from "./UpdateMain.vue?vue&type=script&lang=js"
export * from "./UpdateMain.vue?vue&type=script&lang=js"
import style0 from "./UpdateMain.vue?vue&type=style&index=0&id=6864f0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports